<div class="login-container">
  <otui-card>
    <div class="card-outer">
      <div class="card-inner">
        <div class="hero" *ngIf="showHero">
          <h1>{{ title }}</h1>
          <p>{{ description }}</p>
          <img width="300" src="{{ heroSrc }}" alt="{{ heroAlt }}" />
        </div>
        <div class="form">
          <form
            [formGroup]="loginForm"
            autocomplete="on"
            (ngSubmit)="onSubmit()"
          >
            <lib-text-input
              formControlName="email"
              label="Email"
              autocomplete="username"
            ></lib-text-input>
            @if (showAgeEligibilityFields) {
            <label for="login-date-of-birth">Date of birth</label>
            <input
              id="login-date-of-birth"
              type="date"
              formControlName="dateOfBirth"
              autocomplete="bday"
              required
            />
            } @if (showGuardianEmailField) {
            <label for="login-guardian-email">Parent or guardian email</label>
            <input
              id="login-guardian-email"
              type="email"
              formControlName="guardianEmail"
              autocomplete="email"
              required
            />
            }
            <lib-text-input
              formControlName="password"
              label="Password"
              type="password"
              autocomplete="current-password"
            ></lib-text-input>
            @if (errorMessage) {
            <p class="auth-error" role="alert">{{ errorMessage }}</p>
            }
            <otui-button type="submit" [disabled]="pending">
              {{ pending ? 'Signing in…' : 'Login' }}
            </otui-button>
          </form>
          <div class="email-auth-actions" aria-label="Email sign in options">
            <button
              type="button"
              (click)="requestMagicLink()"
              [disabled]="emailActionPending"
            >
              Email me a magic link
            </button>
            <button
              type="button"
              (click)="requestPasswordReset()"
              [disabled]="emailActionPending"
            >
              Forgot password?
            </button>
            <button
              type="button"
              (click)="requestVerification()"
              [disabled]="emailActionPending"
            >
              Resend verification
            </button>
          </div>
          @if (emailActionStatus) {
          <p class="email-auth-status" role="status">{{ emailActionStatus }}</p>
          }
          <lib-oauth-buttons
            *ngIf="showOAuth"
            [enabledProviders]="enabledOAuthProviders"
            (providerSelected)="onOAuthProvider($event)"
          ></lib-oauth-buttons>
        </div>
      </div>
    </div>
  </otui-card>
</div>
